import { Badge } from '@synoptic/ui-kit/badge/badge.js';
import { ShareAndroidIcon } from '@synoptic/ui-kit/icons/react/share-android.js';
import { Wrap } from '@synoptic/ui-kit/wrap.js';
import { clsx } from 'clsx';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import { badge, labelContent, postLabelIcon } from './post-label.css.ts';

export const StreamLabel = ({
  label,
  streamId,
  className,
  linkToStream = false,
}: {
  label: string;
  streamId: string;
  className?: string;
  linkToStream?: boolean;
}) => (
  <Wrap if={linkToStream} with={Link} to={paths.makeStream(streamId)}>
    <Badge
      color={'auxLightBlue'}
      className={clsx(badge, className)}
      interactive={linkToStream}
    >
      <ShareAndroidIcon className={postLabelIcon} />
      <span className={labelContent}>{label}</span>
    </Badge>
  </Wrap>
);
